import { useMemo } from "react";
import { useLanguage } from "./useLanguage";

export function useMonthNames(
  format: Intl.DateTimeFormatOptions["month"],
): string[] {
  const language = useLanguage();

  return useMemo(() => {
    return Array.from({ length: 12 }).map((_, month) => {
      return new Intl.DateTimeFormat(language, { month: format }).format(
        new Date(2023, month, 1),
      );
    });
  }, [language, format]);
}
